/**
 * @generated SignedSource<<626f212d7e88e19ace9ae89456541152>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FeatureKey = "ADDITIONAL_LISTS" | "BIOMETRIC_LOCK" | "BUDGET" | "ESTATE_SEARCH" | "EXTENDED_ADDRESS_LOOKUP" | "FLOOD_MAP" | "HOME_FEED" | "HOME_OWNERSHIP" | "HOME_RECORDS" | "HOME_UPDATES" | "HOME_UPDATES_PUSH_ANNIVERSARY" | "HOME_UPDATES_PUSH_FLOOD" | "HOME_UPDATES_PUSH_HOME_VALUE" | "HOME_UPDATES_PUSH_PLANNING" | "HOME_UPDATES_PUSH_RATE_DECISION" | "HOME_UPDATES_PUSH_RENT_CHECK" | "HOME_UPDATES_PUSH_SOLD_NEAR_YOU" | "HOUSEHOLD_MONEY" | "JOURNEY_NUDGES" | "LISTING_PHOTO_IMPORT" | "LOCAL_KNOWLEDGE" | "NOISE_INSIGHT" | "PERSONA_JOURNEYS" | "REACHABLE_AREA_SCENE" | "REALTIME_PRESENCE" | "REAL_JOURNEY_TIMES" | "REMOTE_FETCH_IMPORT" | "VIEWINGS" | "VIEWING_NOTE_SUGGESTIONS" | "VOICE" | "%future added value";
export type auditLogQuery$variables = {
  flag?: FeatureKey | null | undefined;
};
export type auditLogQuery$data = {
  readonly auditLog: ReadonlyArray<{
    readonly action: string;
    readonly caller: string;
    readonly id: any;
    readonly newValue: string | null | undefined;
    readonly oldValue: string | null | undefined;
    readonly target: string;
    readonly whenUtc: any;
  }>;
};
export type auditLogQuery = {
  response: auditLogQuery$data;
  variables: auditLogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "flag"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "flag",
        "variableName": "flag"
      }
    ],
    "concreteType": "FeatureToggleAuditEntry",
    "kind": "LinkedField",
    "name": "auditLog",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "action",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "target",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oldValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "caller",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "whenUtc",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "auditLogQuery",
    "selections": (v1/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "auditLogQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d9c5b2a2349a84d5bcd5b02fdf0fdedc",
    "id": null,
    "metadata": {},
    "name": "auditLogQuery",
    "operationKind": "query",
    "text": "query auditLogQuery(\n  $flag: FeatureKey\n) {\n  auditLog(flag: $flag) {\n    id\n    action\n    target\n    oldValue\n    newValue\n    caller\n    whenUtc\n  }\n}\n"
  }
};
})();

(node as any).hash = "6475511769629ac1f811512c8d5aa7af";

export default node;
